// Here instead of in env, as it will make sure you are changing it intentionally
const brandingVersion = '1.1.0';

export const getBrandingOverrides = async (tenantId) => {
  if (!tenantId) return [];

  // Use Vite's import.meta.glob to get all JSON files
  const modules = import.meta.glob('./BrandingOverrides/*.json', {
    eager: true,
  });

  const brandingOverrides = [];

  // Process each module
  Object.values(modules).forEach((resource) => {
    if (resource.tenantGUID === tenantId) {
      if (resource.version !== brandingVersion) {
        throw new Error(
          'incorrect version for theme, expecting version ' + brandingVersion
        );
      }
      brandingOverrides.push(resource);
    }
  });

  return brandingOverrides;
};
